"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateFolderName;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = _interopRequireDefault(require("immutable"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var FolderValidationErrors = _interopRequireWildcard(require("FileManagerCore/static-1.5432/js/enums/FolderValidationErrors"));

var _getDoesStringOnlyContainSpaces = _interopRequireDefault(require("FileManagerCore/static-1.5432/js/utils/getDoesStringOnlyContainSpaces"));

// eslint-disable-next-line
var invalidFolderCharsRegExp = /[#\?&'";:\*\^!\$\|\/%@]/g;

function getI18nKey(suffix) {
  return "FileManagerCore.folderNameValidation." + suffix;
}

function validateFolderName(folderName) {
  if ((0, _getDoesStringOnlyContainSpaces.default)(folderName)) {
    return {
      code: FolderValidationErrors.ONLY_WHITESPACES,
      message: _I18n.default.text(getI18nKey('invalidNameOnlyWhitespace'))
    };
  }

  if (folderName.length > 100) {
    return {
      code: FolderValidationErrors.TOO_LONG,
      message: _I18n.default.text(getI18nKey('tooLong'))
    };
  }

  var matches = folderName.match(invalidFolderCharsRegExp);

  if (matches) {
    var uniqueMatches = new _immutable.default.Set(matches);
    var invalidChars = uniqueMatches.join('');
    return {
      code: FolderValidationErrors.INVALID_CHARS,
      message: (0, _unescapedText.default)(invalidChars.includes('"') ? getI18nKey('invalidCharsSingleQuote') : getI18nKey('invalidCharsDoubleQuote'), {
        invalidChars: invalidChars
      })
    };
  }

  return null;
}

module.exports = exports.default;